import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Save } from 'lucide-react';
import './ETPOS/CommonStyles.css';
import './ETPOS/AddSellStyles.css';
import './CardForm.css';

const AddAgent = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        prefix: 'mr',
        first_name: '',
        last_name: '',
        email: '',
        contact_no: '',
        address: '',
        cmmsn_percent: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Agent added:', formData);
        navigate('/users', { state: { activeTab: 'agents' } });
    };

    return (
        <div className="card-form-container">
            {/* Header */}
            <div className="page-header" style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <button
                    onClick={() => navigate('/users', { state: { activeTab: 'agents' } })}
                    className="btn btn-secondary"
                    style={{ padding: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', width: '40px', height: '40px' }}
                    title="Back"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="19" y1="12" x2="5" y2="12"></line>
                        <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                </button>
                <h3 style={{ margin: 0, fontSize: '1.5rem', color: '#1e293b' }}>Add Sales</h3>
            </div>

            <form id="agentForm" onSubmit={handleSubmit} className="sell-form" style={{ gap: '0.5rem' }}>
                <div className="form-section" style={{ padding: '0.75rem 1.5rem', marginBottom: '0' }}>
                    {/* 3-Column Grid for Inputs */}
                    <div className="form-row" style={{ gap: '1rem', marginBottom: '0.75rem', gridTemplateColumns: 'repeat(3, 1fr)' }}>
                        <div className="form-group">
                            <label>Prefix</label>
                            <select
                                className="form-select"
                                name="prefix"
                                value={formData.prefix}
                                onChange={handleChange}
                            >
                                <option value="mr">Mr</option>
                                <option value="mrs">Mrs</option>
                                <option value="miss">Miss</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>First Name *</label>
                            <input
                                type="text"
                                className="form-input"
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Last Name</label>
                            <input
                                type="text"
                                className="form-input"
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                className="form-input"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Contact Number</label>
                            <input
                                type="text"
                                className="form-input"
                                name="contact_no"
                                value={formData.contact_no}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Commission %</label>
                            <input
                                type="number"
                                className="form-input"
                                name="cmmsn_percent"
                                value={formData.cmmsn_percent}
                                onChange={handleChange}
                                step="0.01"
                            />
                        </div>
                    </div>

                    {/* Address Field - Full Width */}
                    <div className="form-row" style={{ gap: '1rem', marginBottom: '0.75rem' }}>
                        <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                            <label>Address</label>
                            <textarea
                                className="form-textarea"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                rows="3"
                            />
                        </div>
                    </div>
                </div>

                <div className="action-buttons-section" style={{ margin: '1rem', padding: '0 0.5rem' }}>
                    <div className="action-buttons" style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
                        <button
                            type="submit"
                            className="save-btn"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                padding: '0.5rem 1.25rem',
                                backgroundColor: '#3b82f6',
                                border: 'none',
                                borderRadius: '6px',
                                color: 'white',
                                fontSize: '0.9rem',
                                fontWeight: '500',
                                cursor: 'pointer'
                            }}
                        >
                            <Save size={16} /> Save Agent
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddAgent;
